/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertsPage,
    InternalApiAlertsPageFromJSON,
    InternalApiAlertsPageToJSON,
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
    InternalApiMonitoringAlert,
    InternalApiMonitoringAlertFromJSON,
    InternalApiMonitoringAlertToJSON,
    InternalApiScenarioType,
    InternalApiScenarioTypeFromJSON,
    InternalApiScenarioTypeToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
} from '../models';

export interface FindAllAlertsInternalRequest {
    page: number;
    size: number;
    statuses?: Array<string>;
    scenarioTypes?: Array<InternalApiScenarioType>;
    activeAssigneeId?: string;
    personId?: string;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
    scenarioIds?: string;
    entityType?: InternalApiEntityType;
    reason?: string;
}

export interface FindMonitoringAlertsByTransactionIdRequest {
    transactionId: string;
}

export interface GetAlertInternalRequest {
    alertId: number;
}

/**
 * 
 */
export class MonitoringAlertInternalApi extends runtime.BaseAPI {

    /**
     * Fetch all monitoring alerts
     */
    async findAllAlertsInternalRaw(requestParameters: FindAllAlertsInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertsPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllAlertsInternal.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllAlertsInternal.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.statuses) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        if (requestParameters.scenarioTypes) {
            queryParameters['scenarioTypes'] = requestParameters.scenarioTypes;
        }

        if (requestParameters.activeAssigneeId !== undefined) {
            queryParameters['activeAssigneeId'] = requestParameters.activeAssigneeId;
        }

        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.scenarioIds !== undefined) {
            queryParameters['scenarioIds'] = requestParameters.scenarioIds;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.reason !== undefined) {
            queryParameters['reason'] = requestParameters.reason;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/monitoring-alerts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all monitoring alerts
     */
    async findAllAlertsInternal(requestParameters: FindAllAlertsInternalRequest, initOverrides?: RequestInit): Promise<InternalApiAlertsPage> {
        const response = await this.findAllAlertsInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findMonitoringAlertsByTransactionIdRaw(requestParameters: FindMonitoringAlertsByTransactionIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiMonitoringAlert>>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling findMonitoringAlertsByTransactionId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transactions/{transactionId}/monitoring-alerts`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiMonitoringAlertFromJSON));
    }

    /**
     */
    async findMonitoringAlertsByTransactionId(requestParameters: FindMonitoringAlertsByTransactionIdRequest, initOverrides?: RequestInit): Promise<Array<InternalApiMonitoringAlert>> {
        const response = await this.findMonitoringAlertsByTransactionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAlertInternalRaw(requestParameters: GetAlertInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiMonitoringAlert>> {
        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
            throw new runtime.RequiredError('alertId','Required parameter requestParameters.alertId was null or undefined when calling getAlertInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/monitoring-alerts/{alertId}`.replace(`{${"alertId"}}`, encodeURIComponent(String(requestParameters.alertId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiMonitoringAlertFromJSON(jsonValue));
    }

    /**
     */
    async getAlertInternal(requestParameters: GetAlertInternalRequest, initOverrides?: RequestInit): Promise<InternalApiMonitoringAlert> {
        const response = await this.getAlertInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
